import type {
  IAccountRewards,
  IPromo,
  IAccountPromoReason,
} from "@apis/rewards/types"
import type { IValueLabel } from "@apis/shared/types"

import { serializeRewardsSection } from "@pages/AccountPage/utils/rewardsInfoSerializerSchema"

export const transformRewardsData = (
  data: IAccountRewards,
  account_id: string,
) => ({
  rewardsSection: serializeRewardsSection(data, account_id),
})

export const transformAvailablePromosData = (
  data: IPromo[],
  measure?: string,
): IValueLabel[] =>
  data
    .filter((p) => !measure || p.promo_measure === measure)
    .map((p) => ({
      value: p.promo_code,
      label: p.promo_name,
    }))

export const transformPromoReasons = (
  data: IAccountPromoReason[],
): IValueLabel[] =>
  data.map((reason) => ({
    value: reason.account_promo_reason_code,
    label: reason.account_promo_reason_desc,
  }))
